// extracted by mini-css-extract-plugin
export default {"wrapper":"TopSection_wrapper__fwZHO","logo":"TopSection_logo__fDz4Q"};